import {hasPermission} from "../../../../../configs/functions";
import {TableCell, TableRow} from "@mui/material";

export function RetiradaRow({ data }) {
    const {
        idRetiradaExtra,
        pessoa,
        produto,
        equipamento,
        tipoAutenticacao,
        dataRetirada,
        quantidadeProduto
    } = data;

    const produtoInfo = produto
        ? `${produto.nome} ${produto?.ca ? '-' + produto?.ca : ''}`
        : `${produto?.nome || 'Não Informado'} ${produto?.ca ? '-' + produto?.ca : ''}`;

    return (
        <TableRow sx={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
            <TableCell sx={{ flex: 1, border: 0 }}>{pessoa?.matricula || 'Sem matrícula'}</TableCell>
            <TableCell sx={{ flex: 2, border: 0 }}>{pessoa?.nome || 'Sem nome'}</TableCell>
            <TableCell sx={{ flex: 2, border: 0 }}>{produtoInfo || 'Desconhecido'}</TableCell>
            <TableCell sx={{ flex: 1, border: 0 }}>{equipamento?.nome || 'Desconhecido'}</TableCell>
            <TableCell sx={{ flex: 1, border: 0 }}>{tipoAutenticacao || 'Desconhecido'}</TableCell>
            <TableCell sx={{ flex: 1, border: 0 }}>{dataRetirada || 'Desconhecido'}</TableCell>
            <TableCell sx={{ flex: 1, border: 0 }}>{quantidadeProduto || '-'}</TableCell>
            <TableCell sx={{ flex: 1, border: 0 }}>{idRetiradaExtra ? 'Sim' : 'Não'}</TableCell>
        </TableRow>
    );
}